import { Grid, MenuItem, Select, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LayoutAlternative } from '@thive/fddm-types';

import { useFloorplanImportExport } from '@/modules/floorplanV2/hooks';
import { ProjectServiceConnector } from '@/modules/api/ProjectApiConnector';

import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';
import { logger } from '@common/logging/logger';

export function DownloadFloorplanButton() {
  const { projectId } = useParams();
  const { downloadFloorplan } = useFloorplanImportExport();
  const [selected, setSelected] = useState('');
  const [layoutAlternatives, setLayoutAlternatives] = useState<LayoutAlternative[]>([]);

  const onChange = useCallback(async () => {
    downloadFloorplan();
    setSelected('');
  }, [downloadFloorplan]);

  useEffect(() => {
    const controller = new AbortController();

    ProjectServiceConnector.getInstance()
      .getLayoutAlternatives({ projectId: projectId ?? '' })
      .then((alternatives) => {
        if (!controller.signal.aborted) setLayoutAlternatives(alternatives);
      })
      .catch((err) => {
        if (!controller.signal.aborted) logger.error('Failed to load layout alternatives', err);
      });

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Download selected floor plan</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Select onChange={onChange} value={selected}>
          {layoutAlternatives.map((item) => (
            <MenuItem id={item.alternativeId} value={item.alternativeId} key={item.alternativeId}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </>
  );
}
